import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';

import {SliderService} from "../slider.service";

@Component({
  selector: 'app-slider-controls',
  templateUrl: './slider-controls.component.html',
  styleUrls: ['./slider-controls.component.scss']
})
export class SliderControlsComponent implements OnInit, OnDestroy {
  @Output() controlClick = new EventEmitter();
  hideControls = false;
  private sliderSub = null;

  constructor(private sliderService: SliderService) {
  }

  ngOnInit(): void {
    this.sliderSub = this.sliderService.hideControls.subscribe(hideControls => {
      this.hideControls = hideControls;
    });
  }

  ngOnDestroy(): void {
    if (this.sliderSub) {
      this.sliderSub.unsubscribe();
    }
  }

  onControlClick(isLeft: boolean) {
    this.controlClick.emit(isLeft);
  }
}
